<template>
  <div class="header">
    <div class="ng-header-v4-topbar">
            <div class="header-content-wrapper">
                <div class="header-content-lt">
                    <div class="language-btn">
                        <a class="language-btn-item" href="#language">
                            <div class="language-btn-inner">
                                Language
                            </div>
                        </a>
                    </div>
                    <div class="rss-btn">
                        <a href="https://www.cgtn.com/subscribe/rss.html" class="rss-btn-item" target="_self"
                            data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                            data-index="" data-news-id="" data-time="">
                            <div class="rss-btn-inner">
                                RSS
                            </div>
                        </a>
                    </div>
                    <div class="newsletters-btn">
                        <a href="https://www.cgtn.com/subscribe/newsletter.html" class="newsletters-btn-item"
                            target="_self" data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                            data-position="" data-index="" data-news-id="" data-time="">
                            <div class="newsletters-btn-inner">
                                Newsletters
                            </div>
                        </a>
                    </div>
                </div>
                <div class="header-content-md">
                    <a href="https://www.cgtn.com" class="bar-logo" target="_self" data-category="Home" data-list=""
                        data-action="Nav_Click" data-label="" data-position="" data-index="" data-news-id=""
                        data-time="">
                    </a>
                </div>
                <div class="header-content-rt J_login_warp" data-domain="https://www.cgtn.com">
                    <div class="NEWSPAL-btn">
                        <a href="https://www.cgtn.com/newspal" class="bar-logo" target="_self" data-category="Home"
                            data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            <div class="NEWSPAL-img">
                            </div>
                        </a>
                    </div>
                    <div class="follow-us-btn">Follow us</div>

                    <div class="sign-in-Pc">
                        <div class="title-item title-item-sign J_login">
                            <span class="signin_value">Sign in</span>
                            <span class="signin_value_acitve">
                                <i class="sign_in_usericon"></i>
                                <i class="sign_in_user">User</i>
                            </span>
                            <div class="title-login-content J_login_content">
                                <p></p>
                                <a class="J_accout">Your account</a>
                                <a class="J_signout">Sign out</a>
                            </div>
                        </div>
                        <div class="title-item-message J_msg"><i class="icon-default"></i></div>
                    </div>

                    <div class="sign-in-iPhone">
                        <div class="m-title-item m-title-item-sign J_login_m">
                            <span class="m_signin_value">Sign in</span>
                            <span class="m_signin_value_active">
                                <i class="sign_in_usericon"></i>
                                <i class="sign_in_user">User</i>
                            </span>
                            <div class="m-title-login-content J_login_content">
                                <a class="J_accout">Your account</a>
                                <a class="J_signout">Sign out</a>
                            </div>
                        </div>
                        <div class="m-title-item m-title-item-message J_msg"><i class="icon-default"></i></div>

                    </div>

                </div>
            </div>
        </div>
        <!-- 监听点 -->
        <div ref="stickyTrigger" class="sticky-trigger"></div>
        <!-- 监听点 -->
        <div class="ng-header-v4-nav-wrapper" :class="{fixed:isFixed}">
            <div class="nav-content">
                <div class="nav-content-lt">
                    <input type="checkbox" id="menu-toggle" class="menu-toggle" autocomplete="off">
                    <label for="menu-toggle" class="menu-icon"></label>
                </div>
                <div class="nav-content-md">
                    <div class="nav-item-wrapper" data-page="Home">
                        <a href="https://www.cgtn.com" class="nav-item" target="_self" data-category="Home" data-list=""
                            data-action="Nav_Click" data-label="" data-position="" data-index="" data-news-id=""
                            data-time="">
                            Home </a>

                    </div>
                    <div class="nav-item-wrapper" data-page="Home">
                        <a href="https://www.cgtn.com/china" class="nav-item" target="_self" data-category="Home"
                            data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            China </a>

                    </div>
                    <div class="nav-item-wrapper" data-page="Home">
                        <a href="https://www.cgtn.com/world" class="nav-item" target="_self" data-category="Home"
                            data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            World </a>

                    </div>
                    <div class="nav-item-wrapper" data-page="Home">
                        <a href="https://www.cgtn.com/politics" class="nav-item" target="_self" data-category="Home"
                            data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            Politics </a>

                    </div>
                    <div class="nav-item-wrapper" data-page="Home">
                        <a href="https://www.cgtn.com/business" class="nav-item" target="_self" data-category="Home"
                            data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            Business </a>

                    </div>
                    <div class="nav-item-wrapper" data-page="Home">
                        <a href="https://www.cgtn.com/sci-tech" class="nav-item" target="_self" data-category="Home"
                            data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            Sci-Tech </a>

                    </div>
                    <div class="nav-item-wrapper" data-page="Home">
                        <a href="https://www.cgtn.com/health" class="nav-item" target="_self" data-category="Home"
                            data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            Health </a>

                    </div>
                    <div class="nav-item-wrapper" data-page="Home">
                        <a href="https://www.cgtn.com/opinions" class="nav-item" target="_self" data-category="Home"
                            data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            Opinions </a>

                    </div>
                    <div class="nav-item-wrapper" data-page="Home">
                        <a href="https://www.cgtn.com/video" class="nav-item" target="_self" data-category="Home"
                            data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            Video </a>

                    </div>
                </div>
                <div class="nav-content-rt">
                    <div class="nav-item-wrapper">
                        <a href="https://www.cgtn.com/live" class="nav-item" target="_self" data-category="Home"
                            data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            Live </a>

                    </div>
                    <div class="nav-item-wrapper">
                        <a href="https://radio.cgtn.com" class="nav-item" target="_self" data-category="Home"
                            data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            Radio </a>

                    </div>
                    <div class="nav-item-wrapper">
                        <a href="https://www.cgtn.com/tv" class="nav-item" target="_self" data-category="Home"
                            data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                            data-news-id="" data-time="">
                            TV </a>

                    </div>
                </div>
            </div>
            <div class="display-menu">
                <div class="left-menu">
                    <div class="search-area">
                        <div class="search-wrapper">
                            <input class="search-input" placeholder="Ask or search">
                            <div class="search-button">
                                <div class="NEWSPAL-logo">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="left-menu-tp">
                        <div class="left-menu-tp-wrapper">
                            <div class="left-menu-tp-content">Choose your language</div>
                            <div class="left-menu-tp-arrow"></div>
                        </div>
                        <div class="left-menu-tp-wrapper-m">
                            <div class="left-menu-tp-content">Choose your language</div>
                            <div class="left-menu-tp-arrow"></div>
                        </div>
                    </div>
                    <div class="scroll-content">
                        <div class="choose-language-wrapper-m">
                            <div class="choose-language-content-m">
                                <a href="https://albanian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Albanian</div>
                                    <div class="lang-name2">Shqip</div>
                                </a>
                                <a href="//arabic.cgtn.com" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Arabic</div>
                                    <div class="lang-name2">العربية</div>
                                </a>
                                <a href="https://belarusian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Belarusian</div>
                                    <div class="lang-name2">Беларуская</div>
                                </a>
                                <a href="https://bangla.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Bengali</div>
                                    <div class="lang-name2">বাংলা</div>
                                </a>
                                <a href="https://bulgarian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Bulgarian</div>
                                    <div class="lang-name2">Български</div>
                                </a>
                                <a href="https://cambodian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Cambodian</div>
                                    <div class="lang-name2">ខ្មែរ</div>
                                </a>
                                <a href="https://croatian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Croatian</div>
                                    <div class="lang-name2">Hrvatski</div>
                                </a>
                                <a href="https://czech.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Czech</div>
                                    <div class="lang-name2">Český</div>
                                </a>
                                <a href="https://www.cgtn.com/tv" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">English</div>
                                    <div class="lang-name2">English</div>
                                </a>
                                <a href="https://esperanto.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Esperanto</div>
                                    <div class="lang-name2">Esperanto</div>
                                </a>
                                <a href="https://filipino.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Filipino</div>
                                    <div class="lang-name2">Filipino</div>
                                </a>
                                <a href="//francais.cgtn.com" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">French</div>
                                    <div class="lang-name2">Français</div>
                                </a>
                                <a href="https://german.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">German</div>
                                    <div class="lang-name2">Deutsch</div>
                                </a>
                                <a href="https://greek.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Greek</div>
                                    <div class="lang-name2">Ελληνικά</div>
                                </a>
                                <a href="https://hausa.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Hausa</div>
                                    <div class="lang-name2">Hausa</div>
                                </a>
                                <a href="https://hebrew.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Hebrew</div>
                                    <div class="lang-name2">עברית</div>
                                </a>
                                <a href="https://hungarian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Hungarian</div>
                                    <div class="lang-name2">Magyar</div>
                                </a>
                                <a href="https://hindi.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Hindi</div>
                                    <div class="lang-name2">हिन्दी</div>
                                </a>
                                <a href="https://indonesian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Indonesian</div>
                                    <div class="lang-name2">Bahasa Indonesia</div>
                                </a>
                                <a href="https://italian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Italian</div>
                                    <div class="lang-name2">Italiano</div>
                                </a>
                                <a href="https://japanese.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Japanese</div>
                                    <div class="lang-name2">日本語</div>
                                </a>
                                <a href="https://korean.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Korean</div>
                                    <div class="lang-name2">한국어</div>
                                </a>
                                <a href="https://laos.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Lao</div>
                                    <div class="lang-name2">ລາວ</div>
                                </a>
                                <a href="https://malay.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Malay</div>
                                    <div class="lang-name2">Bahasa Melayu</div>
                                </a>
                                <a href="https://mongol.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Mongolian</div>
                                    <div class="lang-name2">Монгол</div>
                                </a>
                                <a href="https://myanmar.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Myanmar</div>
                                    <div class="lang-name2">မြန်မာဘာသာ</div>
                                </a>
                                <a href="https://nepal.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Nepali</div>
                                    <div class="lang-name2">नेपाली</div>
                                </a>
                                <a href="https://persian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Persian</div>
                                    <div class="lang-name2">فارسی</div>
                                </a>
                                <a href="https://polish.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Polish</div>
                                    <div class="lang-name2">Polski</div>
                                </a>
                                <a href="https://portuguese.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Portuguese</div>
                                    <div class="lang-name2">Português</div>
                                </a>
                                <a href="https://pashto.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Pashto</div>
                                    <div class="lang-name2">پښتو</div>
                                </a>
                                <a href="https://romanian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Romanian</div>
                                    <div class="lang-name2">Română</div>
                                </a>
                                <a href="//russian.cgtn.com" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Russian</div>
                                    <div class="lang-name2">Русский</div>
                                </a>
                                <a href="https://serbian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Serbian</div>
                                    <div class="lang-name2">Српски</div>
                                </a>
                                <a href="https://sinhala.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Sinhalese</div>
                                    <div class="lang-name2">සිංහල</div>
                                </a>
                                <a href="//espanol.cgtn.com" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Spanish</div>
                                    <div class="lang-name2">Español</div>
                                </a>
                                <a href="https://swahili.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Swahili</div>
                                    <div class="lang-name2">Kiswahili</div>
                                </a>
                                <a href="https://tamil.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Tamil</div>
                                    <div class="lang-name2">தமிழ்</div>
                                </a>
                                <a href="https://thai.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Thai</div>
                                    <div class="lang-name2">ไทย</div>
                                </a>
                                <a href="https://turkish.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Turkish</div>
                                    <div class="lang-name2">Türkçe</div>
                                </a>
                                <a href="https://ukrainian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Ukrainian</div>
                                    <div class="lang-name2">Українська</div>
                                </a>
                                <a href="https://urdu.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Urdu</div>
                                    <div class="lang-name2">اردو</div>
                                </a>
                                <a href="https://vietnamese.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Vietnamese</div>
                                    <div class="lang-name2">Tiếng Việt</div>
                                </a>
                            </div>
                        </div>
                        <div class="left-menu-md">
                            <a href="https://www.cgtn.com" class="nav-item " target="_self" data-category="Home"
                                data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                                data-news-id="" data-time="">
                                Home
                            </a>
                            <a href="https://www.cgtn.com/china" class="nav-item " target="_self" data-category="Home"
                                data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                                data-news-id="" data-time="">
                                China
                            </a>
                            <div class="nav-item nav-item-normal world-item">
                                World
                                <div class="nav-item-arrow"></div>

                            </div>
                            <div class="nav-item nav-item-m world-item">
                                World
                                <div class="nav-item-arrow"></div>
                            </div>
                            <div class="children-nav-list-wrapper-m">
                                <div class="children-nav-list">
                                    <a href="https://www.cgtn.com/world" class="children-nav-item" target="_self"
                                        data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                        data-position="" data-index="" data-news-id="" data-time="">
                                        World </a>

                                    <a href="https://www.cgtn.com/world/asia-pacific" class="children-nav-item"
                                        target="_self" data-category="Home" data-list="" data-action="Nav_Click"
                                        data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                        Asia-Pacific </a>

                                    <a href="https://www.cgtn.com/world/middle-east" class="children-nav-item"
                                        target="_self" data-category="Home" data-list="" data-action="Nav_Click"
                                        data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                        Middle East </a>

                                    <a href="https://www.cgtn.com/europe" class="children-nav-item" target="_self"
                                        data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                        data-position="" data-index="" data-news-id="" data-time="">
                                        Europe </a>

                                    <a href="https://www.cgtn.com/world/americas" class="children-nav-item"
                                        target="_self" data-category="Home" data-list="" data-action="Nav_Click"
                                        data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                        Americas </a>

                                    <a href="https://www.cgtn.com/africa" class="children-nav-item" target="_self"
                                        data-category="Home" data-list="" data-action="Nav_Click" data-label=""
                                        data-position="" data-index="" data-news-id="" data-time="">
                                        Africa </a>

                                </div>
                            </div>
                            <a href="https://www.cgtn.com/politics" class="nav-item " target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Politics
                            </a>
                            <a href="https://www.cgtn.com/business" class="nav-item " target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Business
                            </a>
                            <a href="https://www.cgtn.com/sci-tech" class="nav-item " target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Sci-Tech
                            </a>
                            <a href="https://www.cgtn.com/health" class="nav-item " target="_self" data-category="Home"
                                data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                                data-news-id="" data-time="">
                                Health
                            </a>
                            <a href="https://www.cgtn.com/culture" class="nav-item " target="_self" data-category="Home"
                                data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                                data-news-id="" data-time="">
                                Culture
                            </a>
                            <a href="https://www.cgtn.com/nature" class="nav-item " target="_self" data-category="Home"
                                data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                                data-news-id="" data-time="">
                                Nature
                            </a>
                            <a href="https://www.cgtn.com/travel" class="nav-item " target="_self" data-category="Home"
                                data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                                data-news-id="" data-time="">
                                Travel
                            </a>
                            <a href="https://www.cgtn.com/sports" class="nav-item " target="_self" data-category="Home"
                                data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                                data-news-id="" data-time="">
                                Sports
                            </a>
                            <a href="https://www.cgtn.com/live" class="nav-item live-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Live
                            </a>
                            <a href="https://www.cgtn.com/opinions" class="nav-item " target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Opinions
                            </a>
                            <a href="https://www.cgtn.com/documentary" class="nav-item " target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Documentary
                            </a>
                            <a href="https://www.cgtn.com/gstringer" class="nav-item " target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Global Stringer
                            </a>
                            <a href="https://www.cgtn.com/clab" class="nav-item " target="_self" data-category="Home"
                                data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                                data-news-id="" data-time="">
                                Creative Lab
                            </a>
                            <a href="https://www.cgtn.com/v-studio" class="nav-item " target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Art &amp; Design
                            </a>
                            <a href="https://radio.cgtn.com" class="nav-item " target="_self" data-category="Home"
                                data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                                data-news-id="" data-time="">
                                Radio
                            </a>
                            <a href="https://www.cgtn.com/video" class="nav-item " target="_self" data-category="Home"
                                data-list="" data-action="Nav_Click" data-label="" data-position="" data-index=""
                                data-news-id="" data-time="">
                                Video
                            </a>
                            <a href="https://chatgroup.user.cgtn.com/share/index.html" class="nav-item " target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Chat Group
                            </a>
                        </div>
                        <div class="left-menu-bm" id="left-menu-bm">
                            <div class="follow-us-title">Follow CGTN on:</div>
                            <div class="follow-us-content">
                                <div class="share-item-wrapper">
                                    <a href="https://www.facebook.com/ChinaGlobalTVNetwork"
                                        class="icon fb cg-com-sprite" target="_blank" data-category="Home" data-list=""
                                        data-action="Socialmedia_Click" data-label="" data-position="" data-index=""
                                        data-news-id="" data-time="">
                                    </a>
                                    <div></div>
                                </div>
                                <div class="share-item-wrapper">
                                    <a href="https://twitter.com/CGTNOfficial" class="icon twitter cg-com-sprite"
                                        target="_blank" data-category="Home" data-list=""
                                        data-action="Socialmedia_Click" data-label="" data-position="" data-index=""
                                        data-news-id="" data-time="">
                                    </a>
                                    <div></div>
                                </div>
                                <div class="share-item-wrapper">
                                    <a href="https://www.youtube.com/CGTN" class="icon youtube cg-com-sprite"
                                        target="_blank" data-category="Home" data-list=""
                                        data-action="Socialmedia_Click" data-label="" data-position="" data-index=""
                                        data-news-id="" data-time="">
                                    </a>
                                    <div></div>
                                </div>
                                <div class="share-item-wrapper">
                                    <a href="https://www.instagram.com/cgtn" class="icon ins cg-com-sprite"
                                        target="_blank" data-category="Home" data-list=""
                                        data-action="Socialmedia_Click" data-label="" data-position="" data-index=""
                                        data-news-id="" data-time="">
                                    </a>
                                    <div></div>
                                </div>
                                <div class="share-item-wrapper">
                                    <a href="https://www.pinterest.com/CGTNOfficial"
                                        class="icon pinterest cg-com-sprite" target="_blank" data-category="Home"
                                        data-list="" data-action="Socialmedia_Click" data-label="" data-position=""
                                        data-index="" data-news-id="" data-time="">
                                    </a>
                                    <div></div>
                                </div>
                                <div class="share-item-wrapper">
                                    <a href="https://www.quora.com/profile/CGTN-Social-Team"
                                        class="icon quora cg-com-sprite" target="_blank" data-category="Home"
                                        data-list="" data-action="Socialmedia_Click" data-label="" data-position=""
                                        data-index="" data-news-id="" data-time="">
                                    </a>
                                    <div></div>
                                </div>
                                <div class="share-item-wrapper">
                                    <a href="https://www.linkedin.com/company/cgtn" class="icon linkedin cg-com-sprite"
                                        target="_blank" data-category="Home" data-list=""
                                        data-action="Socialmedia_Click" data-label="" data-position="" data-index=""
                                        data-news-id="" data-time="">
                                    </a>
                                    <div></div>
                                </div>
                                <div class="share-item-wrapper">
                                    <a href="https://www.threads.com/@cgtn" class="icon threads cg-com-sprite"
                                        target="_blank" data-category="Home" data-list=""
                                        data-action="Socialmedia_Click" data-label="" data-position="" data-index=""
                                        data-news-id="" data-time="">
                                    </a>
                                    <div></div>
                                </div>
                                <div class="share-item-wrapper">
                                    <a href="https://t.me/CGTNOfficial_BJ" class="icon telegram cg-com-sprite"
                                        target="_blank" data-category="Home" data-list=""
                                        data-action="Socialmedia_Click" data-label="" data-position="" data-index=""
                                        data-news-id="" data-time="">
                                    </a>
                                    <div></div>
                                </div>
                                <div class="share-item-wrapper">
                                    <a href="https://v.douyin.com/2VMKvpC" class="icon douyin cg-com-sprite"
                                        target="_blank" data-category="Home" data-list=""
                                        data-action="Socialmedia_Click" data-label="" data-position="" data-index=""
                                        data-news-id="" data-time="">
                                    </a>
                                    <div></div>
                                </div>
                                <div class="share-item-wrapper">
                                    <a href="http://weibo.com/cctvnewsbeijing" class="icon weibo cg-com-sprite"
                                        target="_blank" data-category="Home" data-list=""
                                        data-action="Socialmedia_Click" data-label="" data-position="" data-index=""
                                        data-news-id="" data-time="">
                                    </a>
                                    <div></div>
                                </div>
                                <div class="share-item-wrapper">
                                    <div class="wechat-share">
                                        <a href="javascript:;" class="icon wechat cg-com-sprite" target="_self"
                                            data-category="Home" data-list="" data-action="Socialmedia_Click"
                                            data-label="" data-position="" data-index="" data-news-id="" data-time="">
                                        </a>
                                        <div class="header-v4-wechat J-header-v4-wechat">
                                            <img src="https://ui.cgtn.com/ui/attention/attention.jpg" width="150">
                                        </div>
                                    </div>
                                    <div></div>
                                </div>
                                <div class="share-item-wrapper">
                                    <a href="https://www.toutiao.com/c/user/82615367134/#mid=1588042509127693"
                                        class="icon toutiao cg-com-sprite" target="_blank" data-category="Home"
                                        data-list="" data-action="Socialmedia_Click" data-label="" data-position=""
                                        data-index="" data-news-id="" data-time="">
                                    </a>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-mask">
                    <div class="choose-language-wrapper">
                        <div class="choose-language-content">
                            <div>
                                <a href="https://albanian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Albanian</div>
                                    <div class="lang-name2">Shqip</div>
                                </a>
                            </div>
                            <div>
                                <a href="//arabic.cgtn.com" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Arabic</div>
                                    <div class="lang-name2">العربية</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://belarusian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Belarusian</div>
                                    <div class="lang-name2">Беларуская</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://bangla.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Bengali</div>
                                    <div class="lang-name2">বাংলা</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://bulgarian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Bulgarian</div>
                                    <div class="lang-name2">Български</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://cambodian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Cambodian</div>
                                    <div class="lang-name2">ខ្មែរ</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://croatian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Croatian</div>
                                    <div class="lang-name2">Hrvatski</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://czech.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Czech</div>
                                    <div class="lang-name2">Český</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://www.cgtn.com/tv" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">English</div>
                                    <div class="lang-name2">English</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://esperanto.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Esperanto</div>
                                    <div class="lang-name2">Esperanto</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://filipino.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Filipino</div>
                                    <div class="lang-name2">Filipino</div>
                                </a>
                            </div>
                            <div>
                                <a href="//francais.cgtn.com" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">French</div>
                                    <div class="lang-name2">Français</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://german.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">German</div>
                                    <div class="lang-name2">Deutsch</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://greek.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Greek</div>
                                    <div class="lang-name2">Ελληνικά</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://hausa.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Hausa</div>
                                    <div class="lang-name2">Hausa</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://hebrew.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Hebrew</div>
                                    <div class="lang-name2">עברית</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://hungarian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Hungarian</div>
                                    <div class="lang-name2">Magyar</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://hindi.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Hindi</div>
                                    <div class="lang-name2">हिन्दी</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://indonesian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Indonesian</div>
                                    <div class="lang-name2">Bahasa Indonesia</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://italian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Italian</div>
                                    <div class="lang-name2">Italiano</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://japanese.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Japanese</div>
                                    <div class="lang-name2">日本語</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://korean.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Korean</div>
                                    <div class="lang-name2">한국어</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://laos.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Lao</div>
                                    <div class="lang-name2">ລາວ</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://malay.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Malay</div>
                                    <div class="lang-name2">Bahasa Melayu</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://mongol.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Mongolian</div>
                                    <div class="lang-name2">Монгол</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://myanmar.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Myanmar</div>
                                    <div class="lang-name2">မြန်မာဘာသာ</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://nepal.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Nepali</div>
                                    <div class="lang-name2">नेपाली</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://persian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Persian</div>
                                    <div class="lang-name2">فارسی</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://polish.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Polish</div>
                                    <div class="lang-name2">Polski</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://portuguese.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Portuguese</div>
                                    <div class="lang-name2">Português</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://pashto.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Pashto</div>
                                    <div class="lang-name2">پښتو</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://romanian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Romanian</div>
                                    <div class="lang-name2">Română</div>
                                </a>
                            </div>
                            <div>
                                <a href="//russian.cgtn.com" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Russian</div>
                                    <div class="lang-name2">Русский</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://serbian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Serbian</div>
                                    <div class="lang-name2">Српски</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://sinhala.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Sinhalese</div>
                                    <div class="lang-name2">සිංහල</div>
                                </a>
                            </div>
                            <div>
                                <a href="//espanol.cgtn.com" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Spanish</div>
                                    <div class="lang-name2">Español</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://swahili.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Swahili</div>
                                    <div class="lang-name2">Kiswahili</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://tamil.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Tamil</div>
                                    <div class="lang-name2">தமிழ்</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://thai.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Thai</div>
                                    <div class="lang-name2">ไทย</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://turkish.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Turkish</div>
                                    <div class="lang-name2">Türkçe</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://ukrainian.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Ukrainian</div>
                                    <div class="lang-name2">Українська</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://urdu.cgtn.com/" class="lang-item" target="_blank" data-category="Home"
                                    data-list="" data-action="ExploreMore_Click" data-label="" data-position=""
                                    data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Urdu</div>
                                    <div class="lang-name2">اردو</div>
                                </a>
                            </div>
                            <div>
                                <a href="https://vietnamese.cgtn.com/" class="lang-item" target="_blank"
                                    data-category="Home" data-list="" data-action="ExploreMore_Click" data-label=""
                                    data-position="" data-index="" data-news-id="" data-time="">
                                    <div class="lang-name1">Vietnamese</div>
                                    <div class="lang-name2">Tiếng Việt</div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="children-nav-list-wrapper">
                        <div class="children-nav-list">
                            <a href="https://www.cgtn.com/world" class="children-nav-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                World </a>

                            <a href="https://www.cgtn.com/world/asia-pacific" class="children-nav-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Asia-Pacific </a>

                            <a href="https://www.cgtn.com/world/middle-east" class="children-nav-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Middle East </a>

                            <a href="https://www.cgtn.com/europe" class="children-nav-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Europe </a>

                            <a href="https://www.cgtn.com/world/americas" class="children-nav-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Americas </a>

                            <a href="https://www.cgtn.com/africa" class="children-nav-item" target="_self"
                                data-category="Home" data-list="" data-action="Nav_Click" data-label="" data-position=""
                                data-index="" data-news-id="" data-time="">
                                Africa </a>

                        </div>
                    </div>
                </div>
            </div>

            <div class="ng-header-v4-children-nav-wrapper">
                <div class="children-nav-content">
                    <a href="https://www.cgtn.com/world" class="children-nav-item" target="_self" data-category="Home"
                        data-list="" data-action="" data-label="" data-position="" data-index="" data-news-id=""
                        data-time="">
                        World </a>

                    <a href="https://www.cgtn.com/world/asia-pacific" class="children-nav-item" target="_self"
                        data-category="Home" data-list="" data-action="" data-label="" data-position="" data-index=""
                        data-news-id="" data-time="">
                        Asia-Pacific </a>

                    <a href="https://www.cgtn.com/world/middle-east" class="children-nav-item" target="_self"
                        data-category="Home" data-list="" data-action="" data-label="" data-position="" data-index=""
                        data-news-id="" data-time="">
                        Middle East </a>

                    <a href="https://www.cgtn.com/europe" class="children-nav-item" target="_self" data-category="Home"
                        data-list="" data-action="" data-label="" data-position="" data-index="" data-news-id=""
                        data-time="">
                        Europe </a>

                    <a href="https://www.cgtn.com/world/americas" class="children-nav-item" target="_self"
                        data-category="Home" data-list="" data-action="" data-label="" data-position="" data-index=""
                        data-news-id="" data-time="">
                        Americas </a>

                    <a href="https://www.cgtn.com/africa" class="children-nav-item" target="_self" data-category="Home"
                        data-list="" data-action="" data-label="" data-position="" data-index="" data-news-id=""
                        data-time="">
                        Africa </a>

                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      msg: "header",
      isFixed: false,
      observer: null
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        // 触发点离开视口 → fixed
        this.isFixed = !entry.isIntersecting;
      },
      {
        root: null,     // viewport
        threshold: 0
      }
    );

    this.observer.observe(this.$refs.stickyTrigger);
  },
  beforeDestroy() {
    this.observer && this.observer.disconnect();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .header{
        position: relative;
        .sticky-trigger {
            position: absolute;
            top: 90px;    /* 紧贴 topbar 底部 */
            height: 1px;
            width: 100%;
            pointer-events: none;
        }
        .ng-header-v4-nav-wrapper{
            &.fixed{
                position: fixed;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Header_v4.vue